import VritraIcon from "../../../VritraIcon";
import {View,Palette} from "vritra";


export default {
    id:"Palette",
    parent:{name:"View"},
    preview:(props)=>{
        const {parent}=props;
        const view=View({parent,style:`
            display:flex;
            justify-content:center;
            align-items:center;
        `});
        Palette({parent:view,color:mainColor});
        return view;
    },
    props:[
        VritraIcon,
        {
            name:"color",
            type:"string",
            description:"default icon color",
        },
        {
            name:"colors",
            type:"string[]",
            description:`colors to pick from @default red,purple,blue,cyan,green,yellow,orange,black,white`,
        },
        {
            name:"onShowColors",
            type:"(element:Palette):void",
            props:[
                {
                    name:"element",
                    type:"Palette",
                    description:"Palette component HTMLElement",
                }
            ],
        },
        {
            name:"onChange",
            type:"(color:string):void",
        },
    ],
    methods:[
        {
            name:"setColor",
            type:"(color:string,callOnChange:boolean):void",
            description:"Sets the palette color, closes the picker if already open",
            props:[
                {
                    name:"color",
                    type:"string",
                    description:"Color to be set @Value shoud be in colors array otherwise color prop is used",
                },
                {
                    name:"callOnChange",
                    type:"boolean",
                    description:"If true onChange is called, default to true",
                },
            ],
        }
    ],
}
